import styled, { css } from 'styled-components';

import { Box, Avatar, Banner } from '@gympass/yoga';
import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const ChatConversationHeaderRoot = styled(Box).attrs({
  as: 'li',
  d: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})`
  padding: ${({ theme }) =>
    `${theme.yoga.spacing.medium}px ${theme.yoga.spacing.large}px`};
  background-color: ${({ theme }) => theme.yoga.colors.white};
`;

const flexNoShrink = css`
  flex-shrink: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const ChatConversationHeaderAvatar = styled(Avatar.Circle)`
  ${flexNoShrink}
  margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  background-color: ${({ $bgColor, theme }) =>
    $bgColor || theme.yoga.colors.primaryLight};
`;

export const ChatConversationHeaderName = styled.span`
  flex: 1;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;

  :hover {
    cursor: pointer;
  }
`;

export const WarningBanner = styled(Banner)`
  ${({ theme }) => css`
    margin: ${theme.yoga.spacing.zero}px;
    border-radius: ${theme.yoga.radii.sharp}px;
    max-height: ${theme.yoga.spacing.xxxlarge}px;

    svg {
      fill: ${theme.yoga.colors.stamina};
    }
  `}
`;

export const BackButton = styled(IconButton)`
  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

export const BackArrow = styled(ArrowBack)`
  fill: ${wellzTheme.palette.text.secondary};
  height: ${wellzTheme.spacing(3)};
  width: ${wellzTheme.spacing(3)};
`;
